import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { PrelaunchPublicGate, PrelaunchMemberGate } from "./components/PrelaunchGate";
import AIHelpButton from "./components/AIHelpButton";
import IdleTimeoutProvider from "./components/IdleTimeoutProvider";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardLayout from "./components/DashboardLayout";
import DashboardPage from "./pages/DashboardPage";
import InsightsPage from "./pages/InsightsPage";
import GoalsPage from "./pages/GoalsPage";
import ChatPage from "./pages/ChatPage";
import StorePage from "./pages/StorePage";
import ProfilePage from "./pages/ProfilePage";
import WearablesPage from "./pages/WearablesPage";
import NotificationsPage from "./pages/NotificationsPage";
import AdminPage from "./pages/AdminPage";
import SurveyPage from "./pages/SurveyPage";
import AboutPage from "./pages/AboutPage";
import ResearchPage from "./pages/ResearchPage";
import BlogPage from "./pages/BlogPage";
import TermsPage from "./pages/TermsPage";
import ChallengesPage from "./pages/ChallengesPage";
import MembershipPage from "./pages/MembershipPage";
import OrdersPage from "./pages/OrdersPage";
import InfoPage from "./pages/InfoPage";
import LibraryPage from "./pages/LibraryPage";
import SeminarsPage from "./pages/SeminarsPage";
import MedicalRecordsPage from "./pages/MedicalRecordsPage";
import YourCommunityPage from "./pages/YourCommunityPage";
import BodyCompositionPage from "./pages/BodyCompositionPage";
import GroupChatLobbyPage from "./pages/GroupChatLobbyPage";
import GroupChatRoomPage from "./pages/GroupChatRoomPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      {/* Login stays reachable pre-launch so admins can sign in. */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<PrelaunchPublicGate><RegisterPage /></PrelaunchPublicGate>} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/about" element={<PrelaunchPublicGate><AboutPage /></PrelaunchPublicGate>} />
      <Route path="/research" element={<PrelaunchPublicGate><ResearchPage /></PrelaunchPublicGate>} />
      <Route path="/community" element={<PrelaunchPublicGate><YourCommunityPage /></PrelaunchPublicGate>} />
      <Route path="/blog" element={<PrelaunchPublicGate><BlogPage /></PrelaunchPublicGate>} />
      <Route path="/terms" element={<PrelaunchPublicGate><TermsPage /></PrelaunchPublicGate>} />
      <Route path="/info" element={<PrelaunchPublicGate><InfoPage /></PrelaunchPublicGate>} />
      <Route path="/survey" element={
        <ProtectedRoute>
          <PrelaunchMemberGate>
            <SurveyPage />
          </PrelaunchMemberGate>
        </ProtectedRoute>
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <PrelaunchMemberGate>
            <DashboardLayout />
          </PrelaunchMemberGate>
        </ProtectedRoute>
      }>
        <Route index element={<DashboardPage />} />
        <Route path="insights" element={<InsightsPage />} />
        <Route path="goals" element={<GoalsPage />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="chat/groups" element={<GroupChatLobbyPage />} />
        <Route path="chat/groups/:roomId" element={<GroupChatRoomPage />} />
        <Route path="store" element={<StorePage />} />
        <Route path="wearables" element={<WearablesPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile/medical-records" element={<MedicalRecordsPage />} />
        <Route path="profile/body-composition" element={<BodyCompositionPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="challenges" element={<ChallengesPage />} />
        <Route path="library" element={<LibraryPage />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="seminars" element={<SeminarsPage />} />
        <Route path="membership" element={<MembershipPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="payment-success" element={<PaymentSuccessPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <IdleTimeoutProvider>
            <AppRouter />
            <AIHelpButton />
          </IdleTimeoutProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
